// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadingLogo_logoContainer__S9l87 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
}

.LoadingLogo_animatedLogo__FYU1N {
  width: 40px;
  height: 40px;
  animation: LoadingLogo_logoAnimation__NoqLA 2s ease-in-out infinite;
}

@keyframes LoadingLogo_logoAnimation__NoqLA {
  0% {
    transform: scale(1) rotate(0deg);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.2) rotate(180deg);
    opacity: 1;
  }
  100% {
    transform: scale(1) rotate(360deg);
    opacity: 0.8;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/LoadingLogo.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mEAAgD;AAClD;;AAEA;EACE;IACE,gCAAgC;IAChC,YAAY;EACd;EACA;IACE,oCAAoC;IACpC,UAAU;EACZ;EACA;IACE,kCAAkC;IAClC,YAAY;EACd;AACF","sourcesContent":[".logoContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px 0;\n}\n\n.animatedLogo {\n  width: 40px;\n  height: 40px;\n  animation: logoAnimation 2s ease-in-out infinite;\n}\n\n@keyframes logoAnimation {\n  0% {\n    transform: scale(1) rotate(0deg);\n    opacity: 0.8;\n  }\n  50% {\n    transform: scale(1.2) rotate(180deg);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1) rotate(360deg);\n    opacity: 0.8;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoContainer": `LoadingLogo_logoContainer__S9l87`,
	"animatedLogo": `LoadingLogo_animatedLogo__FYU1N`,
	"logoAnimation": `LoadingLogo_logoAnimation__NoqLA`
};
export default ___CSS_LOADER_EXPORT___;
